import { Center, Fade, Icon, Text, VStack } from '@chakra-ui/react'

import { IconComponent } from '@wwt/entities/base'

interface QuickActionTooltipProps {
	isOpen: boolean
	icon: IconComponent
	title: string
	description: string
}

export const QuickActionTooltip = ({
	isOpen,
	icon,
	title,
	description
}: QuickActionTooltipProps) => {
	return (
		// @ts-expect-error Chakra v2 bug with types on react 19
		<Fade
			in={isOpen}
			style={{
				position: 'absolute',
				left: '0.75rem',
				bottom: '2.5rem',
				zIndex: 10,
				display: isOpen ? 'block' : 'none'
			}}
		>
			<VStack
				minW="10.4375rem"
				h="9.0625rem"
				bg="white"
				p="1rem"
				gap="1rem"
				borderRadius="md"
				boxShadow="0 0.125rem 0.75rem 0 #00000040"
				borderColor="gray.200"
				borderWidth="0.0625rem"
				alignItems="flex-start"
				color="black"
				transform={{
					base: 'translateX(-85%)',
					md: 'translateX(0)'
				}}
			>
				<Center
					w="3rem"
					h="3rem"
					borderRadius="100%"
					borderColor="gray.200"
					borderWidth="0.0625rem"
				>
					<Icon as={icon} />
				</Center>
				<VStack
					gap="0.5rem"
					alignItems="flex-start"
				>
					<Text textStyle="body-text-2">{title}</Text>
					<Text textStyle="body-text-7">{description}</Text>
				</VStack>
			</VStack>
		</Fade>
	)
}
